import React from "react";
import GoogleMapReact from "google-map-react";
import pin from "../images/phoenix_pin.png";
import { WithStyles, createStyles, withStyles } from "@material-ui/styles";

interface PinProps {
  lat: number;
  lng: number;
}

const Pin = ({ lat, lng }: PinProps) => {
  return (
    <div>
      <img src={pin} alt="pin" />
    </div>
  );
};

interface MapProps extends WithStyles<typeof styles> {
  lat: number;
  lng: number;
  defaultZoom: number;
}

const Map: React.FunctionComponent<MapProps> = ({
  lat,
  lng,
  defaultZoom,
  classes,
}: MapProps) => {
  return (
    <div className={classes.root}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyBKSqhIfKlxprG-EAA6R4g24GB4J8KoB5g" }}
        defaultCenter={{ lat: lat, lng: lng }}
        defaultZoom={defaultZoom}
      >
        <Pin lat={lat} lng={lng} />
      </GoogleMapReact>
    </div>
  );
};

const styles = createStyles({
  root: {
    height: "500px",
    width: "100%",
  },
});

export default withStyles(styles)(Map);
